import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	containerWrapperSkeleton: {
		alignItems: 'center',
		rowGap: token('space.150'),
		color: token('color.text'),
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
	},
	containerIconSkeleton: {
		borderRadius: token('radius.small'),
		height: '24px',
		width: '24px',
		paddingTop: token('space.100'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.100'),
	},
	labelSkeleton: {
		borderRadius: token('radius.full'),
		paddingBlock: token('space.050'),
		height: '9px',
		width: '100%',
	},
	controlSkeleton: {
		borderRadius: token('radius.xsmall'),
		height: '12px',
		width: '12px',
	},
});

type ItemSkeletonProps = {
	showControl?: boolean;
};

export const ItemSkeleton = ({ showControl = true }: ItemSkeletonProps) => {
	return (
		<Inline space="space.100" xcss={styles.containerWrapperSkeleton}>
			<Box xcss={styles.containerIconSkeleton} backgroundColor="color.background.neutral" />
			<Box xcss={styles.labelSkeleton} backgroundColor="color.background.neutral" />
			{showControl && (
				<Box xcss={styles.controlSkeleton} backgroundColor="color.background.neutral" />
			)}
		</Inline>
	);
};
